import { Flex } from '@chakra-ui/react';
import { ColumnFiltersState, Table } from '@tanstack/react-table';
import { PropsWithChildren } from 'react';

import { MetaData, ResourceType } from '../../_openapi/portfolio-optimizer';
import { ColumnSettings } from './ColumnSettings';
import { ExportCsvButton } from './ExportCsvButton';
import { ExportResults } from './ExportResults';
import { ResetTableFilters } from './ResetTableFilters';

export const TableControls = <T,>({
    table,
    onReset,
    children,
    resourceType,
    metaData,
    exportColumnFilters,
    exportCsvName,
    hideColumnSettings,
}: PropsWithChildren<{
    table: Table<T>;
    onReset?: () => void;
    resourceType?: ResourceType;
    metaData?: MetaData;
    exportColumnFilters?: ColumnFiltersState;
    /** Enables a client-side CSV export of the current (filtered/sorted/visible) rows. */
    exportCsvName?: string;
    /** Hides the "Table Settings" (column visibility/order) button, e.g. when the table drives visibility itself. */
    hideColumnSettings?: boolean;
}>) => {
    return (
        <Flex align="center" borderBottomWidth={1} pb={3} mb={3} gap={2}>
            <Flex flex={1}>{children}</Flex>

            <Flex direction="row" ml="auto" gap={2}>
                {resourceType && (
                    <ExportResults
                        table={table}
                        resourceType={resourceType}
                        metaData={metaData}
                        columnFilters={exportColumnFilters}
                    />
                )}
                {exportCsvName && <ExportCsvButton table={table} exportName={exportCsvName} />}
                <ResetTableFilters table={table} onReset={onReset} />
                {!hideColumnSettings && <ColumnSettings table={table} />}
            </Flex>
        </Flex>
    );
};
